<div class="message-box" [ngClass]="{'unread': message.unread}">
    <span class="name">{{message.name}}</span>
    <span class="perfil">{{message.perfil}} {{message.time_comment}}</span>
    <div class="line"></div>
    <p class="comment" style="white-space: pre-wrap">
        {{message.comment}}
    </p>
</div>